export class NotificationStateChangeData {
    notificationId: number;
    dmcUser: boolean;
    resourceId: number;
    supplierId: number;
    groupThreadId: number;
}
